import { render, staticRenderFns } from "./NotificationHaveNotContent.vue?vue&type=template&id=748a1960&scoped=true&"
import script from "./NotificationHaveNotContent.vue?vue&type=script&lang=js&"
export * from "./NotificationHaveNotContent.vue?vue&type=script&lang=js&"
import style0 from "./NotificationHaveNotContent.vue?vue&type=style&index=0&id=748a1960&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748a1960",
  null
  
)

export default component.exports